import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HomeIcon from '@mui/icons-material/Home';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BuildIcon from '@mui/icons-material/Build';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import AboutUsSection from './AboutUsSection';
import IndustriesSection from './IndustriesSection';

const STATS = [
  { value: '24', label: 'Aktivnih vozila' },
  { value: '7', label: 'Putnih naloga danas' },
  { value: '3', label: 'Servisnih rokova' },
  { value: '1.240 L', label: 'Gorivo ovaj mesec' },
];

const CARDS = [
  { bgcolor: '#e6f1fb', titleColor: '#0c447c', iconBg: '#1a6fc4', Icon: DescriptionIcon, title: 'Kreiranje putnih naloga', desc: 'Generiši i štampaj putne naloge za vozače', to: '/travelOrder' },
  { bgcolor: '#eaf3de', titleColor: '#27500a', iconBg: '#3b6d11', Icon: CalendarTodayIcon, title: 'Planovi vožnji', desc: 'Rasporedi vožnje po vozilima i vozačima', to: '/travelOrder' },
  { bgcolor: '#faeeda', titleColor: '#633806', iconBg: '#854f0b', Icon: BuildIcon, title: 'Registracija i servisi', desc: 'Rokovi, istorija servisa i dokumenti vozila', to: '/servisi' },
  { bgcolor: '#e1f5ee', titleColor: '#085041', iconBg: '#0f6e56', Icon: LocalGasStationIcon, title: 'Gorivo i kvarovi', desc: 'Evidencija potrošnje i beleženje kvarova', to: '/gorivo' },
];

const VEHICLE_STATUS = [
  { label: 'Na terenu', value: 14, total: 24, color: '#22c55e' },
  { label: 'U bazi', value: 7, total: 24, color: '#94a3b8' },
  { label: 'Na servisu', value: 2, total: 24, color: '#f59e0b' },
  { label: 'Kvar', value: 1, total: 24, color: '#ef4444' },
];

const FUEL_DATA = [
  { month: 'Nov', pct: 60, color: '#b5d4f4' },
  { month: 'Dec', pct: 75, color: '#b5d4f4' },
  { month: 'Jan', pct: 50, color: '#b5d4f4' },
  { month: 'Feb', pct: 80, color: '#b5d4f4' },
  { month: 'Mar', pct: 67, color: '#b5d4f4' },
  { month: 'Apr', pct: 89, color: '#378add' },
  { month: 'Maj', pct: 100, color: '#1a6fc4' },
];

const RECENT = [
  { icon: '📄', title: 'Putni nalog #1042 – M. Nikolić', sub: 'Beograd – Novi Sad · 4. maj', badge: 'Završen', badgeBg: '#dcfce7', badgeColor: '#166534' },
  { icon: '⛽', title: 'Tankovanje – VW Transporter BG-123-AB', sub: '50 L · Petrol · 3. maj', badge: 'Evidentirano', badgeBg: '#dbeafe', badgeColor: '#1e40af' },
  { icon: '🔧', title: 'Servis – Ford Transit BG-456-CD', sub: 'Zamena ulja · Rok: 15. maj', badge: 'Predstojeći', badgeBg: '#fef3c7', badgeColor: '#92400e' },
];

const SIDEBAR = [
  { Icon: DescriptionIcon, active: true, to: '/travelOrder' },
  { Icon: DirectionsCarIcon, active: false, to: '/vehicle' },
  { Icon: AccessTimeIcon, active: false, to: '/servisi' },
  { Icon: HomeIcon, active: false, to: '/' },
];

const LandingPage = () => {

  const { loggedUser } = useSelector((state) => state.security);
 
  return (
    <div className="wrapper-fade-in-long">

      {/*  Hero  */}
      <Box sx={{
        position: 'relative',
        backgroundImage: `url(${require('../../../assets/images/slika.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        px: { xs: 3, md: 4 },
        py: { xs: 8, md: 12 },

      }}>
        {/* Overlay */}
        <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(10,30,55,0.72)' }} />

        {/* Kontent */}
        <Box sx={{ position: 'relative', zIndex: 1, px: '180px' }}>
          <Box sx={{ display: 'inline-block', bgcolor: 'rgba(90,190,138,0.2)', border: '0.5px solid rgba(90,190,138,0.35)', borderRadius: '12px', px: 1.5, py: 0.4, mb: 1.5 }}>
            <Typography sx={{ color: '#7dd9a8', fontSize: '0.85rem' }}>Fleet menadžment sistem</Typography>
          </Box>

          <Typography sx={{ color: 'white', fontWeight: 500, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.2, mb: 2 }}>
            Upravljajte voznim parkom<br />
            <Box component="span" sx={{ color: '#5abe8a' }}>brže i preciznije</Box>
          </Typography>

          <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: { xs: '1rem', md: '1.1rem' }, lineHeight: 1.8, mb: 4, maxWidth: 550 }}>
            Pratite putne naloge, planove vožnji, registracije, servise i potrošnju goriva — sve na jednom mestu.
          </Typography>


          {Object.keys(loggedUser).length > 0  && (
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button component={Link} to="/travelOrder"
                sx={{ bgcolor: '#5abe8a', color: '#0d2a1a', textTransform: 'none', fontSize: '0.95rem', fontWeight: 600, px: 3, py: 1.2, borderRadius: '10px', '&:hover': { bgcolor: '#4aab78' } }}>
                + Novi putni nalog
              </Button>
              <Button component={Link} to="/vehicle" variant="outlined"
                sx={{ color: '#5abe8a !important', borderColor: 'rgba(255,255,255,0.25)', textTransform: 'none', fontSize: '0.95rem', px: 3, py: 1.2, borderRadius: '10px', '&:hover': { borderColor: 'rgba(255,255,255,0.5)', bgcolor: 'rgba(255,255,255,0.05)' } }}>
                Pregled vozila
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      <AboutUsSection />
      <IndustriesSection />


      {/*  Stats bar  */}
      {/* <Box sx={{ display: 'flex', bgcolor: 'white', borderBottom: '0.5px solid #f0f0f0' }}>
        {STATS.map((s, i) => (
          <Box key={i} sx={{ flex: 1, py: 1.5, px: 1, textAlign: 'center', borderRight: i < STATS.length - 1 ? '0.5px solid #f0f0f0' : 'none' }}>
            <Typography sx={{ fontSize: '1rem', fontWeight: 500, color: '#1a6fc4' }}>{s.value}</Typography>
            <Typography sx={{ fontSize: '0.62rem', color: '#9ca3af', mt: 0.25 }}>{s.label}</Typography>
          </Box>
        ))}
      </Box> */}

      {/* Body  */}
      {/* <Box sx={{ display: 'flex', bgcolor: '#f8f9fa', minHeight: '60vh' }}> */}


      {/* Sidebar */}
      {/* <Box sx={{ width: 48, bgcolor: 'white', borderRight: '0.5px solid #f0f0f0', display: { xs: 'none', md: 'flex' }, flexDirection: 'column', alignItems: 'center', pt: 1.5, gap: 0.75, flexShrink: 0 }}>
          {SIDEBAR.map(({ Icon, active, to }, i) => (
            <Box key={i} component={Link} to={to}
              sx={{ width: 30, height: 30, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: active ? '#e6f1fb' : 'transparent', color: active ? '#1a6fc4' : '#9ca3af', '&:hover': { bgcolor: '#f3f4f6' }, textDecoration: 'none' }}>
              <Icon sx={{ fontSize: 16 }} />
            </Box>
          ))}
        </Box> */}

      {/* Glavni kontent */}
      {/* <Box sx={{ flex: 1, p: 2, display: 'flex', flexDirection: 'column', gap: 1.75 }}> */}

      {/* Upozorenje */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#fef3c7', border: '0.5px solid #fbbf24', borderRadius: '8px', px: 1.5, py: 1 }}>
            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#d97706', flexShrink: 0 }} />
            <Box>
              <Typography sx={{ fontSize: '0.7rem', color: '#92400e', fontWeight: 500 }}>Ford Transit BG-456-CD – servis ističe za 11 dana</Typography>
              <Typography sx={{ fontSize: '0.65rem', color: '#b45309' }}>Rok registracije: 15. maj 2026.</Typography>
            </Box>
          </Box> */}

      {/* Kartice */}
      {/* <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
            {CARDS.map((c, i) => (
              <Box key={i} component={Link} to={c.to}
                sx={{ bgcolor: c.bgcolor, borderRadius: '10px', p: 1.5, textDecoration: 'none', display: 'block', cursor: 'pointer', '&:hover': { opacity: 0.88 } }}>
                <Box sx={{ width: 26, height: 26, borderRadius: '6px', bgcolor: c.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
                  <c.Icon sx={{ fontSize: 14, color: 'white' }} />
                </Box>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 500, color: c.titleColor, mb: 0.4 }}>{c.title}</Typography>
                <Typography sx={{ fontSize: '0.63rem', color: c.titleColor, opacity: 0.7, lineHeight: 1.4 }}>{c.desc}</Typography>
                <Typography sx={{ fontSize: '0.68rem', mt: 0.75, opacity: 0.45, color: c.titleColor }}>→</Typography>
              </Box>
            ))}
          </Box> */}

      {/* panel */}
      {/* <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.25 }}> */}

      {/* Status vozila */}
      {/* <Box sx={{ bgcolor: 'white', border: '0.5px solid #f0f0f0', borderRadius: '10px', p: 1.5 }}>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 500, color: '#111827', mb: 1.5 }}>Status vozila</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {VEHICLE_STATUS.map((v, i) => (
                  <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: v.color, flexShrink: 0 }} />
                    <Typography sx={{ fontSize: '0.68rem', color: '#374151', flex: 1 }}>{v.label}</Typography>
                    <Box sx={{ flex: 2, height: 6, bgcolor: '#f3f4f6', borderRadius: '3px', overflow: 'hidden' }}>
                      <Box sx={{ height: '100%', width: `${(v.value / v.total) * 100}%`, bgcolor: v.color, borderRadius: '3px' }} />
                    </Box>
                    <Typography sx={{ fontSize: '0.68rem', fontWeight: 500, color: '#374151', minWidth: 18, textAlign: 'right' }}>{v.value}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ mt: 1.5, pt: 1.25, borderTop: '0.5px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ fontSize: '0.62rem', color: '#9ca3af' }}>Ukupno vozila</Typography>
                <Typography sx={{ fontSize: '0.68rem', fontWeight: 500, color: '#111827' }}>24</Typography>
              </Box>
            </Box> */}

      {/* Gorivo-potrosnja */}
      {/* <Box sx={{ bgcolor: 'white', border: '0.5px solid #f0f0f0', borderRadius: '10px', p: 1.5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 500, color: '#111827' }}>Gorivo – potrošnja (L)</Typography>
                <Typography sx={{ fontSize: '0.62rem', color: '#9ca3af' }}>poslednjih 7 meseci</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '5px', height: 90 }}>
                {FUEL_DATA.map((d, i) => (
                  <Box key={i} sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.4, height: '100%', justifyContent: 'flex-end' }}>
                    <Box sx={{ width: '100%', height: `${d.pct}%`, bgcolor: d.color, borderRadius: '3px 3px 0 0' }} />
                    <Typography sx={{ fontSize: '0.52rem', color: '#9ca3af' }}>{d.month}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1, pt: 1, borderTop: '0.5px solid #f0f0f0' }}>
                <Typography sx={{ fontSize: '0.62rem', color: '#9ca3af' }}>Prosek: 980 L/mes</Typography>
                <Typography sx={{ fontSize: '0.62rem', fontWeight: 500, color: '#1a6fc4' }}>↑ +26% vs prošli mesec</Typography>
              </Box> */}
      {/* </Box>
          </Box> */}

      {/* Nedavna aktivnost */}
      {/* <Box>
            <Typography sx={{ fontSize: '0.82rem', fontWeight: 500, color: '#111827' }}>Nedavna aktivnost</Typography>
            <Typography sx={{ fontSize: '0.68rem', color: '#9ca3af', mt: 0.1, mb: 1.25 }}>Poslednji unosi u sistemu</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              {RECENT.map((r, i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#f9fafb', border: '0.5px solid #f0f0f0', borderRadius: '7px', px: 1.25, py: 0.9 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 26, height: 26, bgcolor: '#f3f4f6', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.85rem' }}>
                      {r.icon}
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: '0.68rem', fontWeight: 500, color: '#111827' }}>{r.title}</Typography>
                      <Typography sx={{ fontSize: '0.62rem', color: '#9ca3af' }}>{r.sub}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ fontSize: '0.62rem', px: 1, py: 0.25, borderRadius: '10px', bgcolor: r.badgeBg, color: r.badgeColor, fontWeight: 500, whiteSpace: 'nowrap' }}>
                    {r.badge}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box> */}

      {/* </Box>
      </Box> */}

    </div>
  );
};

export default LandingPage;
